import { render, staticRenderFns } from "./DesktopChildServiceFilter.vue?vue&type=template&id=0191136e&"
import script from "./DesktopChildServiceFilter.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DesktopChildServiceFilter.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports